import React from 'react';
import { useLocation } from 'react-router-dom';

const PublicShopInfo = () => {
  const location = useLocation<{ search: string }>();
  const params = new URLSearchParams(location.search);
  return (
    <div
      style={{
        margin: 'auto',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <h2>
        Votre paiement n'a pas abouti{' '}
        <span role="img" aria-label="oups">
          😕
        </span>
      </h2>
      <p>
        Votre paiement n'a pu aboutir . Veuillez vérifier votre moyen de
        paiement.{params.get('error') && 'Code:' + params.get('error')}
      </p>
    </div>
  );
};
export default PublicShopInfo;
